import {
    Box,
    Image,
    Text,
  } from '@chakra-ui/react';
  import { useEffect } from 'react';
  
  const steps = [
    { title: 'First', description: 'Select a File' },
    { title: 'Second', description: 'File Uploading' },
    { title: 'Third', description: 'Document Validation' },
  ];
  
  interface StepperPropsInterface {
    activeIndex: number;
    successSteps: number;
    errorIndex: number;
  }
  
  export default function Steppers({ activeIndex, successSteps, errorIndex }: StepperPropsInterface) {
    return (
      <Box className="stepper-main-box">
        {steps.map((step, index) => {
          return (
            <Box key={`stepper_${index}`} className='stepper-main-box-wrapper'>
              <Box className={`stepper-box 
                ${((index + 1) <= successSteps) ? 'success-box' : ''}
                ${((index + 1) == errorIndex) ? 'error-box' : ''}
                ${(index + 1) <= activeIndex ? 'active-box' : ''}
                `}>
                {((index + 1) == errorIndex) && (
                  <Image width="12px" height="12px" src="/images/ui/white-close.svg" />
                )}
                {((index + 1) <= successSteps) && (
                  <Image width="12px" height="12px" src="/images/ui/check.svg" />
                )}
                <Text className='stepper-title'>{step.description}</Text>
              </Box>
              {steps.length !== (index + 1) && (
                <Box className={`stepper-box-indicator 
                  ${(index + 1) <= activeIndex ? 'active-indicator' : ''} 
                  ${((index) < successSteps) ? 'success-indicator' : ''}
                  ${((index + 1) == errorIndex) ? 'error-indicator' : ''}
                `} />
              )}
            </Box>
          );
        })}
      </Box >
    );
  }
  